var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"card-title my-2 text-dark text-uppercase px-2",staticStyle:{"font-weight":"700"}},[_c('span',{staticStyle:{"color":"#9ccc65"}},[_vm._v(_vm._s(_vm.first))]),_vm._v(" "+_vm._s(_vm.rest))])
}
var staticRenderFns = []

export { render, staticRenderFns }